<template>
    <div class="lms__superadmin_workspaces_edit_onboarding">
        <component-title :size="'medium'">Learner welcome text</component-title>
        <component-text>This text will be displayed on the learner landing page for this workspace.</component-text>
        <form-editor
            :name="'lms-superadmin-workspace-edit-onboarding-text'"
            :disabled="!user.isSuperadmin() && !user.isMasterAdministrator()"
            v-model="workspaceOnboardingText"
        ></form-editor>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import { performReset, performSubmitValidate, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentText from '@/components/default/shared/ComponentText'
import PopNotify from '@/components/default/shared/PopNotify'
import { User } from '@/User'
import FormEditor from '@/components/default/forms/FormEditor'

export default {
  name: 'lms-superadmin-workspace-edit-onboarding',
  components: { FormEditor, PopNotify, ComponentText, ComponentTitle },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    workspaceOnboardingText: {
      get () {
        return this.$store.getters.getLmsSuperadminWorkspaceCustomisationOnboardingsOnboardingText
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminWorkspaceSetCustomisationOnboardingsOnboardingText', value)
      }
    }
  },
  methods: {}
}
</script>
